import {useTranslation} from 'react-i18next';
import {AlertCircle} from 'lucide-react';
import cn from 'clsx';
import {useTheme} from 'styled-components';
import {PATHS} from 'routes/constants';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {useCheckoutSettings} from 'pages/Checkout/hooks/useCheckoutSettings';
import {Button} from '@chekin/guestapp-ui-kit';
import {StatusText} from 'components/StatusText';
import styles from './styles.module.css';

function CheckOutPanelItem() {
  const {t} = useTranslation('check-out');

  const theme = useTheme();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {isAvailable, checkoutFlowStatus, isCheckoutCompleted, isCheckoutEnabled} =
    useCheckoutSettings();

  const handleStartCheckout = () => {
    if (['PAID', 'NOT_STARTED'].includes(checkoutFlowStatus ?? '')) {
      navigate(getFullPath(PATHS.checkout.main));
      return;
    }
    navigate(getFullPath(PATHS.checkout.rateYourStay));
  };

  if (!isCheckoutEnabled) {
    return null;
  }
  return (
    <>
      <div className="h-[1px] bg-gray-200 w-full checkout-panel-item__divider" />
      <div
        className={cn(
          'py-4 px-4 gap-3 flex flex-col md:grid-cols-2 md:items-center md:flex-wrap checkout-panel-item__container',
          isAvailable ? 'md:grid' : '',
        )}
      >
        <div className="flex flex-col gap-3 md:w-full checkout-panel-item__content">
          <div
            className={cn(styles.title, 'md:col-span-2 checkout-panel-item__title')}
            style={{
              fontFamily: theme.fonts.fontFamily.titles.font_name,
              fontWeight: theme.fonts.fontWeight.medium,
              color: theme.colors.branding.fontPrimary,
            }}
          >
            {t('check_out_short')}
          </div>
          {isAvailable && (
            <StatusText
              completed={isCheckoutCompleted}
              texts={{completed: t('all_tasks_completed')}}
            />
          )}
        </div>
        {isAvailable && (
          <>
            <Button
              className="w-full checkout-panel-item__button"
              onClick={handleStartCheckout}
              variant={isCheckoutCompleted ? 'outline' : 'default'}
            >
              {isCheckoutCompleted ? t('view_summary') : t('start_check_out')}
            </Button>
          </>
        )}
        {!isAvailable && (
          <div className="flex items-center gap-2 p-2 bg-gray-100 rounded-md checkout-panel-item__alert md:w-full">
            <AlertCircle
              className="text-gray-500 checkout-panel-item__alert-icon"
              size={20}
            />
            <span className="text-gray-500 checkout-panel-item__alert-text">
              {t('available_on_checkout_day')}
            </span>
          </div>
        )}
      </div>
    </>
  );
}

export {CheckOutPanelItem};
